// Best-effort avatar URL for a candidate/application. Move surfaces
// hand us different payload shapes — some carry `contact.avatar_url`,
// some only `contact.avatar_thumb_url`, contacts list uses the row
// root. Returns `undefined` when no URL is available, in which case
// the kula `Avatar` falls back to deterministic initials + colour
// derived from the candidate name.
export const getCandidateAvatarUrl = (
  application: unknown
): string | undefined => {
  const app = (application ?? {}) as {
    contact?: { avatar_url?: string; avatar_thumb_url?: string };
    candidate?: { avatar_url?: string; avatar_thumb_url?: string };
    avatar_url?: string;
    avatar_thumb_url?: string;
  };
  return (
    app.contact?.avatar_url ||
    app.contact?.avatar_thumb_url ||
    app.candidate?.avatar_url ||
    app.candidate?.avatar_thumb_url ||
    app.avatar_url ||
    app.avatar_thumb_url ||
    undefined
  );
};
